import { twMerge } from "tailwind-merge";
import { IconsProps } from ".";

export const FireAlarm = ({
  className = "text-primary",
  viewBox = "0 0 217 231",
  width = 32,
  height = 32,
  onClick,
}: IconsProps) => (
  <svg
    className={twMerge("cursor-pointer", className)}
    viewBox={viewBox}
    width={`${width}px`}
    height={`${height}px`}
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClick}
  >
    <title>Fire Alarm</title>
    <path
      d="M197.943 34.1918C197.439 33.3649 195.351 30.6303 195.235 30.0381C195.108 29.4073 196.581 27.4228 196.916 26.5074C200.75 16.0693 189.07 7.16959 179.997 13.5617C170.386 20.3345 177.301 35.9571 188.889 33.3418C189.624 33.4802 193.424 39.8646 194.055 40.9492C225.361 94.7897 206.196 166.168 151.002 195.279C150.479 195.556 147.814 197.052 147.545 196.786V189.617L147.11 189.398C119.522 204.598 85.1428 205.944 56.2015 193.583C53.2208 192.31 50.3863 190.571 47.3672 189.51V223.158C47.3672 226.331 52.3286 231.035 55.6438 230.989L139.053 231.001C143.864 230.377 147.187 226.647 147.548 221.843C147.964 216.301 147.133 210.317 147.648 204.732C179.724 189.571 204.097 160.395 212.569 125.793C220.392 93.8398 214.908 62.0447 197.943 34.1994V34.1918ZM58.9206 224.332C53.6708 227.397 50.544 218.166 56.5861 217.347C60.4244 216.828 62.2744 222.374 58.9206 224.332ZM138.587 224.785C133.253 225.493 132.618 217.897 137.56 217.347C142.091 216.843 143.287 224.162 138.587 224.785Z"
      fill="currentColor"
    />
    <path
      d="M194.686 97.3429C194.686 43.5832 151.106 0 97.3429 0C43.5793 0 0 43.5832 0 97.3429C0 151.103 43.5832 194.686 97.3429 194.686C151.103 194.686 194.686 151.103 194.686 97.3429ZM22.7108 97.3429C22.7108 56.125 56.125 22.7108 97.3429 22.7108C138.561 22.7108 171.975 56.125 171.975 97.3429C171.975 122.696 159.329 145.095 140.003 158.583C144.887 147.753 145.357 136.042 142.522 124.115C140.141 114.096 135.453 105.039 131.038 95.8314C130.142 100.947 127.365 105.889 123.042 109C122.88 109.116 121.673 109.969 121.588 109.873C121.831 98.2659 119.434 86.6509 113.908 76.4474C108.385 66.2516 99.4544 57.6058 89.7162 51.429C89.047 51.006 88.2201 50.4214 87.5471 50.0714C87.4086 49.9983 87.4394 49.8445 87.2586 50.0714C86.524 58.175 86.0433 65.9939 83.2472 73.6975C75.7821 94.2661 56.302 107.589 51.4829 129.353C49.2176 139.584 50.6252 149.622 54.8635 158.706C35.4334 145.234 22.7031 122.773 22.7031 97.3352L22.7108 97.3429Z"
      fill="currentColor"
    />
  </svg>
);
